import { SVGProps } from '@components/Icon/types';

export const Chart = ({ fill = '#000', size = 24, ...props }: SVGProps) => (
  <svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <g transform="translate(2, 2)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.77286 0.81839C9.09781 0.818606 9.36159 1.08239 9.36181 1.40735V10.2075L14.9657 17.4121C15.1367 17.6326 15.128 17.9376 14.9578 18.1461L14.8752 18.2287C14.0678 18.8925 13.3363 19.3389 12.5062 19.6167C11.6774 19.894 10.7612 20 9.59037 20C4.30228 19.9998 5.95974e-05 15.6969 0 10.4088C0.000191878 5.1364 3.92047 0.81839 8.77286 0.81839ZM8.18302 2.02356C4.28466 2.35752 1.179 5.97531 1.1788 10.4088C1.17886 15.0472 4.95199 18.821 9.59037 18.8212C10.5664 18.8212 11.3093 18.7442 11.9629 18.5505C12.5639 18.3723 13.0973 18.0916 13.6735 17.6697L8.30784 10.7709C8.227 10.6673 8.18304 10.5392 8.18302 10.4088V2.02356Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.4102 10.6382C19.7353 10.6382 19.9989 10.9021 19.9991 11.2271C19.9991 13.8776 18.8869 16.4348 16.948 18.2437L16.9471 18.2445C16.8381 18.345 16.6946 18.4019 16.5462 18.4019C16.5373 18.4019 16.521 18.4016 16.5032 18.4001C16.3818 18.391 16.266 18.3457 16.1726 18.2692L16.0874 18.1821L10.77 11.5972L10.7692 11.5981C10.6266 11.4225 10.5967 11.1792 10.6944 10.974C10.7923 10.7689 11.0011 10.6383 11.2271 10.6382H19.4102ZM16.5902 16.9286C17.8806 15.5266 18.6631 13.7166 18.7983 11.817H12.4613L16.5902 16.9286Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.4088 0C15.6969 0 19.9998 4.30224 20 9.59037C20 9.91565 19.7354 10.1802 19.4102 10.1802H10.4088C10.0837 10.18 9.8198 9.91548 9.8198 9.59037V0.588959C9.82002 0.264006 10.0838 0.000222607 10.4088 0ZM10.9986 9.00141H18.7983C18.5085 4.83174 15.1683 1.49164 10.9986 1.20165V9.00141Z"
        fill={fill}
      />
    </g>
  </svg>
);

export const ICON_NAME = 'chart';
